import { useCallback } from "react"
import { multipleModalIds, multipleUsersModalOption } from "Pages/Admin/Users/@signals"

export default function useMultipleUsers(selectedData, setSelectedRows) {
	const selectedIds = selectedData.map(({ uid }) => uid)

	const handleOpenModal = useCallback(option => {
		multipleModalIds.value = selectedIds
		multipleUsersModalOption.value = option
		setSelectedRows([])
	}, [])

	return {
		handleOpenModal,
	}
}